import dayjs from 'dayjs';

export const formatDateSafely = (date: unknown): string | null => {
  if (!date) return null;

  if (typeof date === 'string') {
    try {
      const parsedDate = dayjs(date);
      if (parsedDate.isValid()) {
        return parsedDate.format('YYYY-MM-DD');
      }
      return date; // Retorna a string original se não conseguir parsear
    } catch {
      return date;
    }
  }

  if (date instanceof Date) {
    const dayjsDate = dayjs(date);
    if (dayjsDate.isValid()) {
      return dayjsDate.format('YYYY-MM-DD');
    }
    return null;
  }

  if (date && typeof date === 'object') {
    const dateObj = date as Record<string, unknown>;

    if (typeof dateObj.format === 'function') {
      try {
        return (dateObj.format as (format: string) => string)('YYYY-MM-DD');
      } catch {
        return (dateObj.format as (format: string) => string)('yyyy-MM-dd');
      }
    }

    if (typeof dateObj.toISOString === 'function') {
      try {
        return (dateObj.toISOString as () => string)().split('T')[0];
      } catch {
        return null;
      }
    }
    if (dateObj.$d instanceof Date) {
      const dayjsDate = dayjs(dateObj.$d);
      if (dayjsDate.isValid()) {
        return dayjsDate.format('YYYY-MM-DD');
      }
    }

    if (dateObj._d instanceof Date) {
      const dayjsDate = dayjs(dateObj._d);
      if (dayjsDate.isValid()) {
        return dayjsDate.format('YYYY-MM-DD');
      }
    }

    if (typeof dateObj.valueOf === 'function') {
      try {
        const timestamp = (dateObj.valueOf as () => number)();
        const dayjsDate = dayjs(timestamp);
        if (dayjsDate.isValid()) {
          return dayjsDate.format('YYYY-MM-DD');
        }
      } catch {
        return null;
      }
    }
  }

  if (typeof date === 'number') {
    const dayjsDate = dayjs(date);
    if (dayjsDate.isValid()) {
      return dayjsDate.format('YYYY-MM-DD');
    }
  }

  return null;
};
